import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing4 } from 'approot/shared/styles/spacing.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { boxShadowBlack12 } from 'approot/shared/styles/borders.style';

type ActivityBuilderNavControlsProps = {
  $position?: 'left' | 'right';
  $isSmall?: boolean;
};
export const ActivityBuilderNavControls = styled.nav<ActivityBuilderNavControlsProps>`
  ${boxShadowBlack12}

  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(40)};
  display: flex;
  gap: ${rem(spacing4)};
  padding: ${rem(spacing4)};
  position: absolute;
  z-index: 10;
  flex-direction: column;
  transform: translate(0, -50%);
  top: 50%;
  ${({ $position }) =>
    $position === 'right' ? `right: -${rem(28)};` : `left: -${rem(28)};`};
`;
